module.exports = __webpack_public_path__ + "static/media/scratch-off-empty.c3034261.svg";